import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillingFreeItem } from '@classes/billing-free-item';
import { BillingType } from '@enums/billing-type.enum';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-billing-free-item',
  templateUrl: './billing-free-item.component.html',
  styleUrls: ['./billing-free-item.component.scss']
})
export class BillingFreeItemComponent implements OnInit {

  billingFreeItemForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<BillingFreeItemComponent>,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: BillingFreeItem
  ) { }

  ngOnInit() {
    this.initFormBuilder(this.data);
  }
  private initFormBuilder(billingFreeItem?: BillingFreeItem) {
    const fb = this.formBuilder;
    const billingFreeItemForm = this.billingFreeItemForm = fb.group({
      name: fb.control(billingFreeItem?.name, [Validators.required, Validators.maxLength(50)]),
      value: fb.control(billingFreeItem?.value, [Validators.required]),
      tva: fb.control({ value: billingFreeItem?.tva, disabled: true }, [Validators.required, Validators.min(0), Validators.max(100)]),
      priceHtva: fb.control(billingFreeItem?.priceHtva, [Validators.required]),
      priceTva: fb.control({ value: billingFreeItem?.priceTva, disabled: true }, [Validators.required]),

      totalHtva: fb.control({ value: billingFreeItem?.totalHtva, disabled: true }, []),
      totalTva: fb.control({ value: billingFreeItem?.totalTva, disabled: true }, []),
    });

    billingFreeItemForm.controls.tva.valueChanges.subscribe(tva => {
      const quantity = billingFreeItemForm.controls.value.value;
      const priceHtva = billingFreeItemForm.controls.priceHtva.value;
      billingFreeItemForm.controls.priceTva.setValue(Math.abs(priceHtva + (tva / 100 * priceHtva)) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
      billingFreeItemForm.controls.totalHtva.setValue(Math.abs(priceHtva * quantity) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
      billingFreeItemForm.controls.totalTva.setValue(Math.abs((priceHtva + (tva / 100 * priceHtva)) * quantity) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
    });

    billingFreeItemForm.controls.priceHtva.valueChanges.subscribe(priceHtva => {
      const quantity = billingFreeItemForm.controls.value.value;
      const tva = billingFreeItemForm.controls.tva.value;
      billingFreeItemForm.controls.priceTva.setValue(Math.abs(priceHtva + (tva / 100 * priceHtva)) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
      billingFreeItemForm.controls.totalHtva.setValue(Math.abs(priceHtva * quantity) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
      billingFreeItemForm.controls.totalTva.setValue(Math.abs((priceHtva + (tva / 100 * priceHtva)) * quantity) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
    });

    billingFreeItemForm.controls.value.valueChanges.subscribe(quantity => {
      const priceHtva = billingFreeItemForm.controls.priceHtva.value;
      const tva = billingFreeItemForm.controls.tva.value;
      billingFreeItemForm.controls.priceTva.setValue(Math.abs(priceHtva + (tva / 100 * priceHtva)) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
      billingFreeItemForm.controls.totalHtva.setValue(Math.abs(priceHtva * quantity) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
      billingFreeItemForm.controls.totalTva.setValue(Math.abs((priceHtva + (tva / 100 * priceHtva)) * quantity) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1));
    });
  }
  onSubmit() {
    let value = <BillingFreeItem>(this.billingFreeItemForm.value);
    value.tva = this.billingFreeItemForm.controls.tva.value;
    value.priceTva = Math.abs(this.billingFreeItemForm.controls.priceTva.value) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1);
    value.totalHtva = Math.abs(this.billingFreeItemForm.controls.totalHtva.value) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1);
    value.totalTva = Math.abs(this.billingFreeItemForm.controls.totalTva.value) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1);
    value.priceHtva = Math.abs(this.billingFreeItemForm.controls.priceHtva.value) * (this.data.billingType == BillingType.CreditNote ? (-1) : 1);
    this.dialogRef.close({ add: true, value });
  }
  onCancel() {
    this.dialogRef.close({ add: false });
  }
}
